import React from 'react';
import './Terms.scss';

function TermsOfService() {
  return (
    <div className="terms-container">
      <h2>이용약관</h2>
      
      <section>
        <h3>제1조 (목적)</h3>
        <p>
          본 약관은 매쓰테일러(이하 "회사")가 제공하는 AI 기반 수학 문제 생성 및 변형 서비스(이하 "서비스")의 
          이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
        </p>
      </section>

      <section>
        <h3>제2조 (용어의 정의)</h3>
        <ol>
          <li>"서비스"란 회사가 제공하는 AI 기반 수학 문제 생성, 변형, PDF 변환, 이미지 처리 등의 모든 서비스를 의미합니다.</li>
          <li>"회원"이란 본 약관에 동의하고 회사와 이용계약을 체결한 자를 말합니다.</li>
          <li>"아이디(ID)"란 회원의 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인하는 문자와 숫자의 조합을 의미합니다.</li>
          <li>"비밀번호"란 회원이 부여받은 아이디와 일치되는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합을 의미합니다.</li>
          <li>"지갑(Wallet)"이란 서비스 이용을 위한 선불 충전 방식의 결제 수단을 의미합니다.</li>
        </ol>
      </section>

      <section>
        <h3>제3조 (약관의 효력 및 변경)</h3>
        <ol>
          <li>본 약관은 서비스를 이용하고자 하는 모든 회원에 대하여 그 효력을 발생합니다.</li>
          <li>회사는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 본 약관을 변경할 수 있으며, 약관이 변경되는 경우 지체 없이 서비스 화면에 공지합니다.</li>
          <li>회원은 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 탈퇴할 수 있으며, 변경된 약관의 효력 발생일 이후에도 서비스를 계속 이용하는 경우 약관의 변경 사항에 동의한 것으로 간주됩니다.</li>
        </ol>
      </section>

      <section>
        <h3>제4조 (회원가입)</h3>
        <ol>
          <li>회원가입은 이용자가 본 약관의 내용에 동의하고, 회사가 정한 절차에 따라 회원가입 신청을 완료함으로써 이루어집니다.</li>
          <li>회사는 다음 각 호에 해당하는 신청에 대해서는 승인을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
            <ul>
              <li>가입신청자가 본 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
              <li>실명이 아니거나 타인의 명의를 이용한 경우</li>
              <li>허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우</li>
              <li>부정한 용도로 서비스를 사용하고자 하는 경우</li>
            </ul>
          </li>
          <li>회원가입 시 최초 무료 지갑 충전이 제공되며, 충전액은 회사의 정책에 따라 변경될 수 있습니다.</li>
        </ol>
      </section>

      <section>
        <h3>제5조 (회원정보의 변경)</h3>
        <ol>
          <li>회원은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다.</li>
          <li>회원은 회원가입 신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 회사에 대하여 그 변경사항을 알려야 합니다.</li>
        </ol>
      </section>

      <section>
        <h3>제6조 (서비스의 제공 및 변경)</h3>
        <ol>
          <li>회사는 다음과 같은 서비스를 제공합니다.
            <ul>
              <li>AI 기반 수학 문제 생성 및 변형</li>
              <li>문제 풀이 생성</li>
              <li>PDF 문서 변환 및 처리</li>
              <li>이미지 처리 및 텍스트 추출</li>
              <li>기타 회사가 정하는 서비스</li>
            </ul>
          </li>
          <li>회사는 서비스의 내용을 변경할 경우 그 내용 및 제공일자를 명시하여 현재 페이지에 공지합니다.</li>
        </ol>
      </section>

      <section>
        <h3>제7조 (서비스의 중단)</h3>
        <ol>
          <li>회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</li>
          <li>회사는 제1항의 사유로 서비스 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상하지 않습니다.</li>
        </ol>
      </section>

      <section>
        <h3>제8조 (지갑 및 결제)</h3>
        <ol>
          <li>서비스 이용을 위해서는 지갑에 충전이 필요하며, 충전은 회사가 지정한 결제 방법을 통해 이루어집니다.</li>
          <li>지갑 충전 후 서비스 이용 시 사용된 금액은 지갑에서 자동으로 차감됩니다.</li>
          <li>충전된 금액은 원칙적으로 환불되지 않으나, 관련 법령에 따라 예외적으로 환불이 가능할 수 있습니다.</li>
          <li>서비스별 이용 금액은 회사의 정책에 따라 변경될 수 있으며, 변경 시 사전 공지합니다.</li>
        </ol>
      </section>

      <section>
        <h3>제9조 (회원의 의무)</h3>
        <ol>
          <li>회원은 다음 행위를 하여서는 안 됩니다.
            <ul>
              <li>신청 또는 변경 시 허위 내용의 등록</li>
              <li>타인의 정보 도용</li>
              <li>회사가 게시한 정보의 변경</li>
              <li>회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
              <li>회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
              <li>회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
              <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위</li>
            </ul>
          </li>
        </ol>
      </section>

      <section>
        <h3>제10조 (저작권의 귀속 및 이용제한)</h3>
        <ol>
          <li>회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다.</li>
          <li>회원은 서비스를 이용함으로써 얻은 정보 중 회사에게 지적재산권이 귀속된 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.</li>
          <li>회원이 서비스를 이용하여 생성한 콘텐츠의 저작권은 회원에게 귀속되나, 회사는 서비스 개선 및 홍보를 위해 해당 콘텐츠를 사용할 수 있습니다.</li>
        </ol>
      </section>

      <section>
        <h3>제11조 (분쟁해결)</h3>
        <ol>
          <li>회사는 회원이 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.</li>
          <li>회사는 회원으로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 회원에게 그 사유와 처리일정을 즉시 통보해 드립니다.</li>
        </ol>
      </section>

      <section>
        <h3>제12조 (재판권 및 준거법)</h3>
        <ol>
          <li>이 약관에 명시되지 않은 사항은 전기통신사업법 등 관계법령과 상관습에 따릅니다.</li>
          <li>서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 회사의 본사 소재지를 관할하는 법원을 관할 법원으로 합니다.</li>
        </ol>
      </section>

      <section className="terms-footer">
        <p>부칙</p>
        <p>본 약관은 2026년 4월 15일부터 시행됩니다.</p>
      </section>
    </div>
  );
}

export default TermsOfService;
